import "../css/CommonDesign.css";
import video_mv_mp4 from "../video/mv.mp4";
import React, { useState, useEffect, createContext, useContext, useRef } from "react";
import { Autocomplete, Breadcrumbs, Button, Chip, Container, FormControlLabel, FormLabel, Link, Radio, RadioGroup, Stack, TextField, Typography, MenuItem, FormControl, FormHelperText, Table, TableBody, TableCell, TableHead, TableRow, ToggleButton, ToggleButtonGroup, Grid } from "@mui/material";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { debounce } from "lodash";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import dayjs from "dayjs";
import { API } from "./constantsFront";
import { MsgContext } from "../../App";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import parse from 'html-react-parser';
import img_ogp_images from "../images/ogp_images.png";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Helmet from 'react-helmet';

import $ from "jquery";
import MenuMenu from "./MenuMenu";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const D0121RacTop = () => {
  const navigate = useNavigate();

  const location = useLocation()
  let iniCountryName = "お選びください";
  let iniProductName = "お選びください";
  let iniPesticide = [];
  if (location.state != null) {
    let eachData = location.state.eachData;
    iniProductName = eachData.product_name;
    iniCountryName = eachData.country_name;
    if (eachData.pesticide) {
      iniPesticide = [{ pesticide: eachData.pesticide }];
    }
  }

  const [langu, setLangu] = useState("ja"); // 言語

  // よく見られる品目ボタンリスト
  const [seenProductList, setSeenProductList] = useState([]);
  const [hideProductList, setHideProductList] = useState([]);
  // よく見られる輸出先国ボタンリスト
  const [seenCountryList, setSeenCountryList] = useState([]);
  const [hideCountryList, setHideCountryList] = useState([]);

  // hideリストオープン
  const [isProductOpen, setIsProductOpen] = useState(false);
  const [isCountryOpen, setIsCountryOpen] = useState(false);

  // 前回のキーワード
  const [beforePesticide, setBeforePesticide] = useState("");
  const [beforePesticideProducts, setBeforePesticideProducts] = useState("");
  // 表示候補(本来はreduxのuseSelectorなんかでデータを管理する)
  const [pesticideOptions, setPesticideOptions] = useState([]);
  const [pesticideProductsOptions, setPesticideProductsOptions] = useState([]);
  // 選択されている内容
  const [autocompletePesticide, setAutocompletePesticide] = useState(iniPesticide);
  const [autocompletePesticideProducts, setAutocompletePesticideProducts] = useState(iniPesticide);

  const [productName, setProductName] = useState(iniProductName); // 品目名
  const [productList, setProductList] = useState([{ product_name: "お選びください" }]); // 品目リスト

  const [countryName, setCountryName] = useState(iniCountryName); // 国名
  const [countryList, setCountryList] = useState([{ product_name: "お選びください" }]); // 国リスト

  const [standardValueData, setStandardValueData] = useState([]); // 基準値項目

  const [errorProduct, setErrorProduct] = useState("※品目を選択してください"); // 品目エラー
  const [errorPesticide, setErrorPesticide] = useState("※農薬の有効成分名を選択してください"); // 農薬名エラー
  const [errorPesticideProducts, setErrorPesticideProducts] = useState("※農薬の製品名を選択してください"); // 農薬名エラー
  const [errorDialogPesticide, setErrorDialogPesticide] = useState(""); // ダイアログ農薬名エラー
  const [errorDialogPesticideProducts, setErrorDialogPesticideProducts] = useState(""); // ダイアログ農薬名エラー


  // 農薬リスト
  const [jaPesticideList, setJaPesticideList] = useState("");
  const [enPesticideList, setEnPesticideList] = useState("");
  // 農薬の製品名リスト
  const [pesticideProductsList, setPesticideProductsList] = useState("");
  // 和名頭文字リスト
  const [jaIniList, setJaIniList] = useState("");

  const [jaPesticideTabs, setJaPesticideTabs] = useState(""); //ダイアログタブ（和）
  const [enPesticideTabs, setEnPesticideTabs] = useState(""); //ダイアログタブ（英）
  const [jaPesticideDialogContent, setJaPesticideDialogContent] = useState(""); //ダイアログコンテキスト（和）
  const [enPesticideDialogContent, setEnPesticideDialogContent] = useState(""); //ダイアログコンテキスト（英）
  const [pesticideProductsDialogContent, setPesticideProductsDialogContent] = useState(""); //ダイアログコンテキスト（製品名）
  const [isJa, setIsJa] = useState(false);
  const [isEn, setIsEn] = useState(false);

  // ダイアログ関連
  const [jaValue, setJaValue] = useState(0);
  const [enValue, setEnValue] = useState(0);
  const [open, setOpen] = useState(false);
  const [pesticideProductsOpen, setPesticideProductsOpen] = useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [dialogLangu, setDialogLangu] = useState("ja"); // ダイアログ内の言語

  // エラーメッセージ
  const { msg, setMsg } = useContext(MsgContext);

  // POSTデータ
  let body = { authKey: API.API_KEY };

  // useEffect初回読込フラグ
  const refIsFirst = useRef(true);

  useEffect(() => {
    // 初回読込チェック
    if (!refIsFirst.current) {
      return;
    }

    window.scrollTo(0, 0);

    // メッセージ削除
    if (location.state != null) {
      let eachData = location.state.eachData;
      console.log(eachData);
      if (eachData.product_name) {
        setErrorProduct("");
        setErrorPesticideProducts("");
      }
      if (eachData.pesticide) {
        setErrorPesticide("");
        setErrorPesticideProducts("");
      }
    }

    body = { authKey: API.API_KEY };
    // プルダウン-品目
    axios.post("/m_rac_product/select", body).then(res => {
      let productList = [{ product_name: "お選びください" }];
      productList = productList.concat(res.data.dataList);
      setProductList(productList);
    }).catch((err) => {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    });
    // プルダウン-輸出先
    axios.post("/m_rac_export_country/select", body).then(res => {
      let countryList = [{ country_name: "お選びください" }];
      countryList = countryList.concat(res.data.dataList);
      setCountryList(countryList);
    }).catch((err) => {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    });

    displayHistory();

    jaValueMethod(countryName, autocompletePesticide);
    pesticideProductsValueMethod(countryName, autocompletePesticideProducts);

    // 初回読込フラグをfalseにセット
    refIsFirst.current = false;
  }, [])

  // 履歴用
  function displayHistory() {
    // 品目履歴
    body.pageName = "残留農薬";
    body.type = 1;
    axios.post("/t_search_his/select", body).then(res => {
      let productHisList = res.data.dataList;

      // 品目履歴ボタン作成
      let seenProductList = [];
      let hideProductList = [];
      for (let i in productHisList) {
        if (i == 12) {
          // seenProductList.push(<p className="exceeded">・・・</p>);
          break;
        } else {
          let bg = "bg3";
          if (i < 2) {
            bg = "bg1";
          } else if (i < 4) {
            bg = "bg2";
          }
          // let productHis = { product_code: productHisList[i].code, product_name: productHisList[i].name };
          if (i < 6) {
            seenProductList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={(function (value) {
                  return async function () {
                    productSelect(productHisList[i].name);
                  }
                })(productHisList[i].name)}
              >
                <a>{productHisList[i].name}</a>
              </li>);
          } else {
            hideProductList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={(function (value) {
                  return async function () {
                    productSelect(productHisList[i].name);
                  }
                })(productHisList[i].name)}
              >
                <a>{productHisList[i].name}</a>
              </li>);
          }
        }
      }
      setSeenProductList(seenProductList);
      setHideProductList(hideProductList);
    }).catch((err) => {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    });

    // 輸出先国履歴
    body.type = 2;
    axios.post("/t_search_his/select", body).then(res => {
      let counrtyHisList = res.data.dataList;

      // 輸出先国履歴ボタン作成
      let seenCountryList = [];
      let hideCountryList = [];
      for (let i in counrtyHisList) {
        if (i == 12) {
          // seenCountryList.push(<p className="exceeded">・・・</p>);
          break;
        } else {
          let bg = "bg3";
          if (i < 2) {
            bg = "bg1";
          } else if (i < 4) {
            bg = "bg2";
          }
          // let countryHis = { country_code: counrtyHisList[i].code, country_name: counrtyHisList[i].name };
          if (i < 6) {
            seenCountryList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={(function (value) {
                  return async function () {
                    countrySelect(counrtyHisList[i].name);
                  }
                })(counrtyHisList[i].name)}
              >
                <a>{counrtyHisList[i].name}</a>
              </li>);
          } else {
            hideCountryList.push(
              <li
                class={bg}
                style={{ cursor: "pointer" }}
                onClick={(function (value) {
                  return async function () {
                    countrySelect(counrtyHisList[i].name);
                  }
                })(counrtyHisList[i].name)}
              >
                <a>{counrtyHisList[i].name}</a>
              </li>);
          }
        }
      }
      setSeenCountryList(seenCountryList);
      setHideCountryList(hideCountryList);
    }).catch((err) => {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    });
  }

  // 変更が止まった後、指定時間(ミリ秒)後処理を行う
  const term = 200;
  const pesticideSearchHandler = debounce(
    (changeValue) => pesticideSearchMethod(changeValue),
    term
  );
  const pesticideProductsSearchHandler = debounce(
    (pesticideProductsChangeValue) => pesticideProductsSearchMethod(pesticideProductsChangeValue),
    term
  );

  // 有効成分サジェスト用処理
  const pesticideSearchMethod = async (changeValue) => {
    try {
      setBeforePesticide(changeValue);
      // 内容が同じ場合は処理しない
      if (changeValue.length > 0 && beforePesticide !== changeValue) {
        if (productName != "お選びください") {
          body.productName = productName;
          if (langu == "ja") {
            body.pesticide = changeValue;
          } else {
            body.pesticidesName = changeValue;
          }
          body.langu = langu;
          const res = await axios.post("/m_rac_pesticide/select", body);
          setPesticideOptions([...res.data.dataList]);
        }
      } else {
        // オートコンプリートの内容初期化
        setPesticideOptions([]);
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  const pesticideChange = (event, selectedValue) => {
    // 選択されているオートコンプリート内容変更
    setAutocompletePesticide([...selectedValue]);
    // オートコンプリートの内容初期化
    setPesticideOptions([]);

    pesticideSelect(selectedValue);
  };

  // 農薬の有効成分のラベル作成
  function label(option) {
    if (langu == "ja") {
      return option.pesticide;
    } else {
      return option.pesticides_name;
    }
  }

  // 製品名サジェスト用処理
  const pesticideProductsSearchMethod = async (pesticideProductsChangeValue) => {
    try {
      setBeforePesticideProducts(pesticideProductsChangeValue);
      // 内容が同じ場合は処理しない
      if (pesticideProductsChangeValue.length > 0 && beforePesticideProducts !== pesticideProductsChangeValue) {
        if (productName != "お選びください") {
          body.productName = productName;
          body.pesticideName = pesticideProductsChangeValue;
          const res = await axios.post("/m_rac_pesticide_products/select", body);
          let dataList = [...res.data.dataList];
          console.log(dataList)
          let checkRegistration = [];
          let resultDataList = [];
          for (let i in dataList) {
            if (i != 0) {
              if (checkRegistration.includes(dataList[i].registration_number)) {
                continue;
              }
            }
    
            checkRegistration.push(
              dataList[i].registration_number
            );

            resultDataList.push(
              dataList[i]
            );
          }
          setPesticideProductsOptions(resultDataList);
        }
      } else {
        // オートコンプリートの内容初期化
        setPesticideProductsOptions([]);
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  const pesticideProductsChange = (event, selectedValue) => {
    // 選択されているオートコンプリート内容変更
    setAutocompletePesticideProducts([...selectedValue]);
    // オートコンプリートの内容初期化
    setPesticideProductsOptions([]);

    pesticideProductsSelect(selectedValue);
  };

  // 農薬の製品名のラベル作成
  function pesticideProductsLabel(option) {
    return option.pesticide_name;
  }

  // 品目名選択時
  function productSelect(value) {
    setProductName(value);
    setPesticideOptions([]);
    setPesticideProductsOptions([]);
    setAutocompletePesticide([]);
    setAutocompletePesticideProducts([]);
    setStandardValueData([]);
    if (value != "お選びください") {
      setErrorProduct("");
    } else {
      setErrorProduct("※品目を選択してください");
    }
  }

  // 国名選択時
  function countrySelect(value) {
    setCountryName(value);
    jaValueMethod(value, autocompletePesticide);
    pesticideProductsValueMethod(value, autocompletePesticideProducts);
  }

  // 言語選択時
  function languSelect(value) {
    setLangu(value);
    setDialogLangu(value);
    setPesticideOptions([]);
    setPesticideProductsOptions([]);
    setAutocompletePesticide([]);
    setAutocompletePesticideProducts([]);
    setStandardValueData([]);
    setErrorPesticide("※農薬の有効成分名を選択してください");
    setErrorPesticideProducts("※農薬の製品名を選択してください");
  }

  // 農薬の有効成分選択時
  function pesticideSelect(value) {
    if (value.length == 1) {
      setErrorPesticide("");
      setErrorPesticideProducts("");
      setAutocompletePesticideProducts("");
      jaValueMethod(countryName, value);
    } else if (value.length > 1) {
      setStandardValueData([]);
      setErrorPesticide("※農薬の有効成分名は1つのみ選択してください");
    } else {
      setStandardValueData([]);
      setErrorPesticide("※農薬の有効成分名を選択してください");
      setErrorPesticideProducts("※農薬の製品名を選択してください");
    }
  }

  // 農薬の製品名選択時
  function pesticideProductsSelect(value) {
    if (value.length == 1) {
      setErrorPesticide("");
      setErrorPesticideProducts("");
      setAutocompletePesticide("");
      pesticideProductsValueMethod(countryName, value);
    } else if (value.length > 1) {
      setStandardValueData([]);
      setErrorPesticideProducts("※農薬の製品名は1つのみ選択してください");
    } else {
      setStandardValueData([]);
      setErrorPesticide("※農薬の有効成分名を選択してください");
      setErrorPesticideProducts("※農薬の製品名を選択してください");
    }
  }

  // ダイアログ内の言語選択
  const languChange = (event, newlangu) => {
    if (newlangu) {
      setDialogLangu(newlangu);
      setJaValue(0);
      setEnValue(0);

      if (newlangu == "ja") {
        setIsJa(true);
      } else {
        setIsJa(false);
      }
      if (newlangu == "en") {
        setIsEn(true);
      } else {
        setIsEn(false);
      }
      $("#dialog-content").scrollTop(0);
    }
  };

  // 有効成分選択時の基準値作成
  async function jaValueMethod(countryName, autocompletePesticide) {
    try {
      if (productName == "お選びください") {
        return setStandardValueData([]);
      }
      // if (countryName == "お選びください") {
      //   return;
      // }
      if (autocompletePesticide.length != 1) {
        return setStandardValueData([]);
      }

      let jaData;
      let eachData;

      body.productName = productName;
      if (langu == "ja") {
        body.pesticide = autocompletePesticide[0].pesticide;
      } else {
        body.pesticidesName = autocompletePesticide[0].pesticides_name;
      }
      body.countryName = "日本";
      let res = await axios.post("/m_rac_standard_value/select", body);
      if (res.data.dataList.length == 1) {
        jaData = res.data.dataList[0];
      }

      if (countryName != "お選びください") {
        body.countryName = countryName;
        res = await axios.post("/m_rac_standard_value/select", body);
        if (res.data.dataList.length == 1) {
          eachData = res.data.dataList[0];
        }
      }

      // グローバルIP取得
      let ip;
      try {
        await axios.get("https://ipinfo.io").then(res => ip = res.data.ip);
      } catch {
        ip = null;
      }

      // 検索履歴作成
      if (ip) {
        body.ipAddr = ip;
      }

      const kensakuList = [];
      kensakuList.push([{ product_code: productName, product_name: productName }]);
      if (countryName != "お選びください") {
        kensakuList.push([{ country_code: countryName, country_name: countryName }]);
      } else {
        kensakuList.push([]);
      }
      let arrStr = JSON.stringify(kensakuList);
      body.arrStr = arrStr;
      body.pageName = "残留農薬";
      await axios.post("/t_search_his/insert", body);

      if (jaData || eachData) {
        let valueContent = [];
        let tableData = [];

        if (jaData) {
          let isRegist = <div>登録なし</div>
          let isApply = <div>適用なし</div>

          if(jaData.pesticides_name == "FLUAZIFOP-BUTYL"){
            isRegist = <div>{jaData.is_regist}</div>
            isApply = <div>{jaData.is_apply}</div>
          } else {
            if (jaData.is_regist == "○") {
              isRegist = <div>登録あり</div>
            }
            if (jaData.is_apply == "○") {
              isApply = <div>適用あり</div>
            }
          }

          // 日本の基準値取得日の取得
          body.countryName = "日本";
          res = await axios.post("/m_rac_item_common/select", body);
          let acquisition_date_ja = "";
          if (res.data.dataList.length >= 1) {
            let jaItemCommon = res.data.dataList[0];
            acquisition_date_ja = jaItemCommon.acquisition_date ?
              dayjs(jaItemCommon.acquisition_date).format("YYYY年MM月DD日時点の情報を調査し記載しています。")
              : "";
          }

          tableData.push(
            <dl>
              <dt>日本の<br class="forSP" />基準値</dt>
              <dd class="spflexnone">
                <div class="value">
                  <p style={{ fontSize: "13px" }}>{acquisition_date_ja}</p>
                  {parse(jaData.standard_value).replace(/\n/g, '　')}<span>（mg/kg）</span>
                </div>
                <div class="tag">
                  <span>{isRegist}</span>
                  <span>{isApply}</span>
                </div>
                <div class="btn"><a href="http://db.ffcr.or.jp/" target="_blank" class="buttonDefault">基準値確認</a></div>
              </dd>
            </dl>
          );
        }

        if (eachData) {
          // 他国の基準値取得日の取得
          body.countryName = eachData.country_name;
          let res = await axios.post("/m_rac_item_common/select", body);
          let acquisition_date_other = "";
          if (res.data.dataList.length >= 1) {
            let itemCommon = res.data.dataList[0];
            acquisition_date_other = itemCommon.acquisition_date ?
              dayjs(itemCommon.acquisition_date).format("YYYY年MM月DD日時点の情報を調査し記載しています。")
              : "";
          }

          tableData.push(
            <dl>
              <dt>{countryName}の<br class="forSP" />基準値</dt>
              <dd class="spflexnone">
                <div class="value">
                  <p style={{ fontSize: "13px" }}>{acquisition_date_other}</p>
                  {parse(eachData.standard_value).replace(/\n/g, '　')}<span>（mg/kg）</span>
                </div>
                <div class="btn"><a onClick={() => detailClick(jaData, eachData)} class="buttonDefault">基準値確認</a></div>
              </dd>
            </dl>
          );
        }

        valueContent.push(
          <>
            <div class="checkBtnWrap afternone"></div>
            <div class="checkResultWrap">
              <div class="checkTable w100p">
                {tableData}
              </div>
              <div class="checkBorderBox">
                <div class="attention">本サイトで照会できる基準値について</div>
                <p>
                  基準値の設定が無い場合は、各国で定められた優先順位に従い各基準値が運⽤されます。前記ルールに従い各基準値を適⽤済みです。「基準値なし」は、ネガティブリスト制度化では原則使⽤可能です。「対象外」は、ポジティブリスト制度下では原則使⽤可能です。<br />
                  <br />
                  基準値は各国‧地域等のWebサイト等各種情報に基づいて作成しておりますが、正確性を保証するものではありません。本基準値は、調査時点の数値であり、その後変更されていることがあります。輸出前に輸出先国の関係法規を確認してください。
                </p>
              </div>
            </div>
          </>
        );
        setStandardValueData(valueContent);
      } else {
        setStandardValueData(<p>該当するデータが見つかりませんでした</p>);
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  // 製品名選択時の基準値作成
  async function pesticideProductsValueMethod(countryName, autocompletePesticideProducts) {
    try {
      if (productName == "お選びください") {
        return setStandardValueData([]);
      }
      // if (countryName == "お選びください") {
      //   return;
      // }
      if (autocompletePesticideProducts.length != 1) {
        return setStandardValueData([]);
      }

      body.registrationNumber = autocompletePesticideProducts[0].registration_number;
      body.pesticideName = autocompletePesticideProducts[0].pesticide_name;
      body.companyName = autocompletePesticideProducts[0].company_name;
      let pesticideProductsRes = await axios.post("/m_rac_pesticide_products/select", body);
      let pesticideProductsDatalist = pesticideProductsRes.data.dataList;

      let valueContent = [];
      let tableData = [];
      let jaFlag = false;

      for (let i in pesticideProductsDatalist) {
        console.log(tableData)
        console.log(pesticideProductsDatalist)
        console.log(pesticideProductsDatalist[i])
  
        let jaData;
        let eachData;

        body.productName = productName;
        body.countryName = "日本";
        body.pesticide = pesticideProductsDatalist[i].fullsize_pesticide_name;
        let res = await axios.post("/m_rac_standard_value/select", body);
        // if (res.data.dataList.length >= 1) {
          jaData = res.data.dataList[0];
        // }
  
        console.log(jaData)

        if (countryName != "お選びください") {
          body.countryName = countryName;
          res = await axios.post("/m_rac_standard_value/select", body);
          // if (res.data.dataList.length >= 1) {
            eachData = res.data.dataList[0];
          // }
        }

        // グローバルIP取得
        let ip;
        try {
          await axios.get("https://ipinfo.io").then(res => ip = res.data.ip);
        } catch {
          ip = null;
        }

        // 検索履歴作成
        if (ip) {
          body.ipAddr = ip;
        }

        const kensakuList = [];
        kensakuList.push([{ product_code: productName, product_name: productName }]);
        if (countryName != "お選びください") {
          kensakuList.push([{ country_code: countryName, country_name: countryName }]);
        } else {
          kensakuList.push([]);
        }
        let arrStr = JSON.stringify(kensakuList);
        body.arrStr = arrStr;
        body.pageName = "残留農薬";
        await axios.post("/t_search_his/insert", body);

        if (jaData || eachData) {
          jaFlag = true;

          if (jaData) {
            let isRegist = <div>登録なし</div>
            let isApply = <div>適用なし</div>

            if(jaData.pesticides_name == "FLUAZIFOP-BUTYL"){
              isRegist = <div>{jaData.is_regist}</div>
              isApply = <div>{jaData.is_apply}</div>
            } else {
              if (jaData.is_regist == "○") {
                isRegist = <div>登録あり</div>
              }
              if (jaData.is_apply == "○") {
                isApply = <div>適用あり</div>
              }
            }

            // 日本の基準値取得日の取得
            body.countryName = "日本";
            res = await axios.post("/m_rac_item_common/select", body);
            let acquisition_date_ja = "";
            if (res.data.dataList.length >= 1) {
              let jaItemCommon = res.data.dataList[0];
              acquisition_date_ja = jaItemCommon.acquisition_date ?
                dayjs(jaItemCommon.acquisition_date).format("YYYY年MM月DD日時点の情報を調査し記載しています。")
                : "";
            }

            tableData.push(
              <p class="rac-table-title" key={""}>{pesticideProductsDatalist[i].fullsize_pesticide_name}</p>
            );
            tableData.push(
              <dl>
                <dt>日本の<br class="forSP" />基準値</dt>
                <dd class="spflexnone">
                  <div class="value">
                    <p style={{ fontSize: "13px" }}>{acquisition_date_ja}</p>
                    {parse(jaData.standard_value).replace(/\n/g, '　')}<span>（mg/kg）</span>
                  </div>
                  <div class="tag">
                    <span>{isRegist}</span>
                    <span>{isApply}</span>
                  </div>
                  <div class="btn"><a href="http://db.ffcr.or.jp/" target="_blank" class="buttonDefault">基準値確認</a></div>
                </dd>
              </dl>
            );
          }

          if (eachData) {
            // 他国の基準値取得日の取得
            body.countryName = eachData.country_name;
            let res = await axios.post("/m_rac_item_common/select", body);
            let acquisition_date_other = "";
            if (res.data.dataList.length >= 1) {
              let itemCommon = res.data.dataList[0];
              acquisition_date_other = itemCommon.acquisition_date ?
                dayjs(itemCommon.acquisition_date).format("YYYY年MM月DD日時点の情報を調査し記載しています。")
                : "";
            }

            tableData.push(
              <dl>
                <dt>{countryName}の<br class="forSP" />基準値</dt>
                <dd class="spflexnone">
                  <div class="value">
                    <p style={{ fontSize: "13px" }}>{acquisition_date_other}</p>
                    {parse(eachData.standard_value).replace(/\n/g, '　')}<span>（mg/kg）</span>
                  </div>
                  <div class="btn"><a onClick={() => detailClick(jaData, eachData)} class="buttonDefault">基準値確認</a></div>
                </dd>
              </dl>
            );
          }
        }
      };
      if (jaFlag) {
        valueContent.push(
          <>
            <div class="checkBtnWrap afternone"></div>
            <div class="checkResultWrap">
              <div class="checkTable w100p">
                {tableData}
              </div>
              <div class="checkBorderBox">
                <div class="attention">本サイトで照会できる基準値について</div>
                <p>
                  基準値の設定が無い場合は、各国で定められた優先順位に従い各基準値が運⽤されます。前記ルールに従い各基準値を適⽤済みです。「基準値なし」は、ネガティブリスト制度化では原則使⽤可能です。「対象外」は、ポジティブリスト制度下では原則使⽤可能です。<br />
                  <br />
                  基準値は各国‧地域等のWebサイト等各種情報に基づいて作成しておりますが、正確性を保証するものではありません。本基準値は、調査時点の数値であり、その後変更されていることがあります。輸出前に輸出先国の関係法規を確認してください。
                </p>
              </div>
            </div>
          </>
        );
        setStandardValueData(valueContent);
      } else {
        setStandardValueData(<p>該当するデータが見つかりませんでした</p>);
      }
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  function detailClick(jaData, eachData) {
    // const productName = hinmokuData.product_name;
    // const productCode = hinmokuData.product_code;
    return navigate("/D0122RacDetail", { state: { eachData: eachData, jaData: jaData } });
  }

  // 有効成分ダイアログデータ
  function dialogData(jaPesticideList, enPesticideList, jaIniList, enIniList) {
    try {
      let jaPesticideTabs = [];
      let enPesticideTabs = [];
      let jaPesticideDialogContent = [];
      let enPesticideDialogContent = [];
      // 選択されている農薬名をまとめる
      let selectPesticideList = [];
      for (let i in autocompletePesticide) {
        selectPesticideList.push(autocompletePesticide[i].pesticide);
      }

      // ダイアログ用
      let index = 0;

      // ダイアログ内の作成（和）
      for (let i in jaIniList) {
        let jaInitials = jaIniList[i].ja_initials;

        jaPesticideTabs.push(<Tab label={jaInitials} {...a11yProps(i)} />);
        let categoryList = [];

        for (let j in jaPesticideList) {
          let pesticide = jaPesticideList[j].pesticide;
          let jaInitials2 = jaPesticideList[j].ja_initials;
          if (jaInitials == jaInitials2) {
            let radio = <input type="radio" name="jaPesticide" value={j} />;
            // let radio = <FormControlLabel type="radio" name="pesticide" value={pesticide} control={<Radio />} label={pesticide} />;
            if (selectPesticideList.includes(pesticide) === true && langu == "ja") {
              radio = <input type="radio" name="jaPesticide" value={j} defaultChecked />;
            }
            categoryList.push(<li><label>{radio}{pesticide}</label></li>);
            // categoryList.push(radio);
          }
        }

        let all = "all" + index;
        let br = <br />;
        if (index == 0) {
          br = "";
        }

        jaPesticideDialogContent.push(
          <>{br}
            <li><label name={all} id={all}>{jaInitials}</label></li><hr />
            <ul>
              {categoryList}
            </ul>
          </>);
        index += 1;
      }

      // ダイアログ内の作成（英）
      for (let i in enIniList) {
        let enInitials = enIniList[i].en_initials;

        enPesticideTabs.push(<Tab label={enInitials} {...a11yProps(jaIniList.length + Number(i))} />);
        let categoryList = [];

        for (let j in enPesticideList) {
          let pesticide = enPesticideList[j].pesticide;
          let pesticidesName = enPesticideList[j].pesticides_name;
          let enInitials2 = enPesticideList[j].en_initials;
          if (enInitials == enInitials2) {
            let radio = <input type="radio" name="enPesticide" value={j} />;
            // let radio = <FormControlLabel type="radio" name="pesticide" value={pesticide} control={<Radio />} label={pesticide} />;
            if (selectPesticideList.includes(pesticide) === true && langu == "en") {
              radio = <input type="radio" name="enPesticide" value={j} defaultChecked />;
            }
            categoryList.push(<li><label>{radio}{pesticidesName}</label></li>);
            // categoryList.push(radio);
          }
        }

        let all = "all" + index;
        let br = <br />;
        if (index == jaIniList.length) {
          br = "";
        }

        enPesticideDialogContent.push(
          <>{br}
            {/* <li><label name={all} id={all}>{enInitials}{dialogLangu}</label></li><hr /> */}
            <li><label name={all} id={all}>{enInitials}</label></li><hr />
            <ul>{categoryList}</ul>
          </>);
        index += 1;
      }

      if (dialogLangu == "ja") {
        setIsJa(true);
      } else {
        setIsJa(false);
      }
      if (dialogLangu == "en") {
        setIsEn(true);
      } else {
        setIsEn(false);
      }
      setJaPesticideTabs(jaPesticideTabs);
      setEnPesticideTabs(enPesticideTabs);
      setJaPesticideDialogContent(jaPesticideDialogContent);
      setEnPesticideDialogContent(enPesticideDialogContent);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  }

  // ダイアログ処理
  function jaDialigChange(event, newValue) {
    setJaValue(newValue);
    //移動したい内容の位置を取得
    let top = $("#all" + newValue).offset().top;
    let all0Top = $("#all0").offset().top;
    //スクロールを移動する
    $("#dialog-content").scrollTop(top - all0Top + 10);
  };
  function enDialigChange(event, newValue) {
    setEnValue(newValue);
    //移動したい内容の位置を取得
    let top = $("#all" + (jaIniList.length + newValue)).offset().top;
    let all0Top = $("#all" + jaIniList.length).offset().top;
    //スクロールを移動する
    $("#dialog-content").scrollTop(top - all0Top + 10);
  };

  async function handleClickOpen() {
    try {
      if (productName == "お選びください") {
        return;
      }
      // 農薬リスト（和）
      body.productName = productName;
      body.langu = "ja";
      let res = await axios.post("/m_rac_pesticide/select", body);
      setJaPesticideList(res.data.dataList);
      const jaEesticideList = res.data.dataList;

      // 農薬リスト（英）
      body.langu = "en";
      res = await axios.post("/m_rac_pesticide/select", body);
      setEnPesticideList(res.data.dataList);
      const enPesticideList = res.data.dataList;

      // 和名頭文字リスト
      res = await axios.post("/m_rac_ja_initials/select", body);
      const jaIniList = res.data.dataList;
      setJaIniList(jaIniList);

      // 英名頭文字リスト
      res = await axios.post("/m_rac_en_initials/select", body);
      const enIniList = res.data.dataList;

      dialogData(jaEesticideList, enPesticideList, jaIniList, enIniList)
      setOpen(true);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };
  
  // 製品名ダイアログデータ
  function pesticideProductsDialogData(pesticideProductsList) {
    try {
      let pesticideProductsDialogContent = [];
      // 選択されている農薬名をまとめる
      let selectPesticideProductsList = [];
      for (let i in autocompletePesticideProducts) {
        selectPesticideProductsList.push(autocompletePesticideProducts[i].pesticide_name);
      }

      // ダイアログ用
      let index = 0;
      let checkRegistration = [];

      // ダイアログ内の作成（製品名）
      for (let i in pesticideProductsList) {
        let pesticideName = pesticideProductsList[i].pesticide_name;
        let registrationNumber = pesticideProductsList[i].registration_number;
        let categoryList = [];

        let radio = <input type="radio" name="pesticideProducts" value={i} defaultChecked/>;
        categoryList.push(<li><label>{radio}{pesticideName}</label></li>);

        let all = "all" + index;
        let br = <br />;
        if (index == pesticideName.length) {
          br = "";
        }

        if (i != 0) {
          if (checkRegistration.includes(registrationNumber)) {
            continue;
          }
        }

        checkRegistration.push(
          registrationNumber
        );

        pesticideProductsDialogContent.push(
          <>
            <ul>
              {categoryList}
            </ul>
          </>
        );
        index += 1;
      }

      setPesticideProductsDialogContent(pesticideProductsDialogContent);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // ダイアログ処理
  async function handlePesticideProductsClickOpen() {
    try {
      if (productName == "お選びください") {
        return;
      }

      // 農薬の製品名リスト
      body.productName = productName;
      let pesticideProductsRes = await axios.post("/m_rac_pesticide_products/select", body);
      setPesticideProductsList(pesticideProductsRes.data.dataList);
      const pesticideProductsList = pesticideProductsRes.data.dataList;

      pesticideProductsDialogData(pesticideProductsList)
      setPesticideProductsOpen(true);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // キャンセルボタン
  function cancelButton() {
    setOpen(false);
    setPesticideProductsOpen(false);
    setJaValue(0);
    setEnValue(0);
  };

  // 有効成分決定ボタン
  function decisionButton() {
    try {
      let pesticideChecked = [];
      let pesticideCheckList;
      let pesticide;
      let pesticidesName;
      if (dialogLangu == "ja") {
        pesticideCheckList = document.getElementsByName("jaPesticide");
      } else if (dialogLangu == "en") {
        pesticideCheckList = document.getElementsByName("enPesticide");
      }
      for (let i = 0; i < pesticideCheckList.length; i++) {
        if (pesticideCheckList[i].checked) {
          if (dialogLangu == "ja") {
            pesticide = jaPesticideList[pesticideCheckList[i].value].pesticide;
            pesticidesName = jaPesticideList[pesticideCheckList[i].value].pesticides_name;
          } else if (dialogLangu == "en") {
            pesticide = enPesticideList[pesticideCheckList[i].value].pesticide;
            pesticidesName = enPesticideList[pesticideCheckList[i].value].pesticides_name;
          }

          pesticideChecked.push({
            pesticide: pesticide,
            pesticides_name: pesticidesName
          });
        }
        setErrorDialogPesticide("");
      }
      if (!pesticidesName) {
        return setErrorDialogPesticide("※農薬名を選択してください");
      }

      if (dialogLangu == "ja") {
        setLangu("ja");
      } else if (dialogLangu == "en") {
        setLangu("en");
      }

      setAutocompletePesticide(pesticideChecked);
      pesticideSelect(pesticideChecked);
      setOpen(false);
      setJaValue(0);
      setEnValue(0);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // 製品名決定ボタン
  function decisionPesticideProductsButton() {
    try {
      let pesticideProductsChecked = [];
      let pesticideProductsCheckList;
      let pesticideName;
      let pesticide;
      let registrationNumber;
      let mixedCount;

      pesticideProductsCheckList = document.getElementsByName("pesticideProducts");

      for (let i = 0; i < pesticideProductsCheckList.length; i++) {
        if (pesticideProductsCheckList[i].checked) {
          pesticide = pesticideProductsList[pesticideProductsCheckList[i].value].fullsize_pesticide_name;
          pesticideName = pesticideProductsList[pesticideProductsCheckList[i].value].pesticide_name;
          registrationNumber = pesticideProductsList[pesticideProductsCheckList[i].value].registration_number;
          mixedCount = pesticideProductsList[pesticideProductsCheckList[i].value].mixed_count;

          pesticideProductsChecked.push({
            pesticide: pesticide,
            pesticide_name: pesticideName,
            registration_number: registrationNumber,
            mixed_count: mixedCount
          });
        }
        setErrorDialogPesticideProducts("");
      }
      if (!pesticideName) {
        return setErrorDialogPesticideProducts("※農薬の製品名を選択してください");
      }

      setAutocompletePesticideProducts(pesticideProductsChecked);
      pesticideProductsSelect(pesticideProductsChecked);
      setPesticideProductsOpen(false);
    } catch (err) {
      return setMsg("例外が発生しました。管理者にお問い合わせください。");
    }
  };

  // よく見られる品目のOpen/Close
  function ProductClick() {
    if (isProductOpen) {
      setIsProductOpen(false);
    } else {
      setIsProductOpen(true);
    }
  }

  // よく見られる輸出先国のOpen/Close
  function CountryClick() {
    if (isCountryOpen) {
      setIsCountryOpen(false);
    } else {
      setIsCountryOpen(true);
    }
  }

  /**
 * タイトル、metaデータ
 */
  const met = {
    title: "残留農薬基準値検索｜海外の食品規則チェックサイト- OMARS",
    description: "15品目×20ゕ国・地域及び国際基準の農薬の最大残留基準値を掲載しています。調査対象農薬成分は、日本において残留農薬基準値の設定がある農薬成分を検索できます。",
    keywords: "残留農薬,要件,規制,検索",

    og_title: "残留農薬基準値検索｜海外の食品規則チェックサイト- OMARS",
    og_description: "15品目×20ゕ国・地域及び国際基準の農薬の最大残留基準値を掲載しています。調査対象農薬成分は、日本において残留農薬基準値の設定がある農薬成分を検索できます。",
    og_image: { img_ogp_images },

    og_url: "https://export-regulations.maff.go.jp/D0121RacTop",
    og_site_name: "残留農薬基準値検索｜海外の食品規則チェックサイト- OMARS",
  }

  return (
    <>
      <Helmet
        title={met.title}
        meta={[
          { name: 'description', content: met.description },
          { property: 'keywords', content: met.keywords },

          { property: 'og:title', content: met.og_title },
          { property: 'og:description', content: met.og_description },
          { property: 'og:image', content: met.og_image },

          { property: 'og:url', content: met.og_url },
          { property: 'og:site_name', content: met.og_site_name },
        ]}
      />

      <MenuMenu sel={2} />

      <div id="homeContents">
        <div class="homeContentsInner">
          <div class="mainCont">

            <Container maxWidth="lg" style={{ paddingLeft: "0", paddingRight: "0" }}>
              <Stack spacing={2}>

                {/* <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                >
                  <Link underline="hover" key="1" color="inherit" href="./">
                    TOP
                  </Link>,
                  <Typography key="2" color="text.primary">
                    残留農薬基準値検索
                  </Typography>
                </Breadcrumbs> */}

                {/* <h1>残留農薬基準値検索</h1> */}

                <div>
                  「残留農薬基準値検索」では、農林⽔産省サイトの「<Link href="https://www.maff.go.jp/j/shokusan/export/zannou_kisei.html" target="_blank">諸外国における残留農薬基準値に関する情報</Link>」に係る「品⽬別残留農薬基準値」のデータを検索‧参照することができます。<br />
                  各当局のWebサイト情報等に基づいて作成しておりますが、正確性を保証するものではありません。<br />
                  本基準値は、調査時点の数値であり、その後変更されていることがあります。輸出前に輸出先国の関係法規を確認してください。<br/>
                  なお、輸出する品目名のうち、かんきつ類、ながいも、コメに関しては、農薬の製品名の検索機能は備えておりませんので、予めご了承ください。<br/>
                  <br/>
                  【帰責事由】<br/>
                  ①農林水産省が本サービスで提供する情報は、独立行政法人農林水産消費安全技術センターホームページから取得した農薬登録情報を農林水産省が加工したものです。提供情報については正確性を期すように努力しておりますが、その正確性、完全性が保証されているものではありません。<br/>
                  <br/>
                  ②情報取得先である独立行政法人農林水産消費安全技術センターは、独立行政法人農林水産消費安全技術センターホームページの情報を用いて当社が行う本サービスの提供等の一切の行為により、直接又は間接的に生じた利用者又はそれ以外の第三者の損害については、その内容、方法の如何にかかわらず、一切責任を負いません。<br/>
                  ※農薬の製品名のデータは、登録時点（令和７年６月時点）の情報であり、その後変更されていることがあります。最新のデータは、独立行政法人農林水産消費安全技術センターのホームページを確認してください。

                </div>

                <div class="selectArea">
                  <Stack spacing={4} direction={{ xs: 'column', sm: 'row' }}>
                    <Stack spacing={0}>

                      <dl>
                        <dt>
                          <FormLabel>輸出する品目名</FormLabel>
                          <span class="hissu">必須</span>
                        </dt>
                        <dd>
                          <TextField id="product" variant="outlined"
                            className="d001_text"
                            style={{ minWidth: "300px", maxWidth: "100%" }}
                            value={productName}
                            //label="輸出する品目名"
                            required
                            select
                            error={Boolean(errorProduct == "" ? false : true)}
                            //helperText={errorProduct}
                            onChange={e => {
                              productSelect(e.target.value);
                            }}
                          >
                            {productList.map((option) => (
                              <MenuItem key={option.product_name} value={option.product_name}>
                                {option.product_name}
                              </MenuItem>
                            ))}
                          </TextField>
                          <br />
                          <FormControl error={errorProduct}>
                            <FormHelperText>{errorProduct}</FormHelperText>
                          </FormControl>
                        </dd>
                      </dl>

                    </Stack>
                    <Stack>

                      <dl>
                        <dt>
                          <FormLabel>輸出先国名</FormLabel>
                        </dt>
                        <dd>
                          <TextField id="country" variant="outlined"
                            className="d001_text"
                            style={{ minWidth: "300px", maxWidth: "100%" }}
                            value={countryName}
                            required
                            select
                            // error={Boolean(countryNameMsg == "" ? false : true)}
                            // helperText={countryNameMsg}
                            onChange={e => {
                              countrySelect(e.target.value, autocompletePesticide, autocompletePesticideProducts);
                            }}
                          >
                            {countryList.map((option) => (
                              <MenuItem key={option.country_name} value={option.country_name}>
                                {option.country_name}
                              </MenuItem>
                            ))}
                          </TextField>

                        </dd>
                      </dl>

                    </Stack>
                  </Stack>
                </div>

                <div class="selectSearchArea">
                  <Stack>
                    <dl>
                      <dt>
                        <FormLabel >農薬の有効成分名</FormLabel>
                        <Stack spacing={2} direction="row">
                          <RadioGroup
                            row
                            name="row-radio-buttons-group"
                            value={langu}
                            onChange={(event) => {
                              languSelect(event.target.value)
                            }}
                          >
                            <FormControlLabel value="ja" control={<Radio />} label="和名" />
                            <FormControlLabel value="en" control={<Radio />} label="英名" />
                          </RadioGroup>
                        </Stack>
                      </dt>

                      <dd>
                        {/* <Button onClick={handleClickOpen}>一覧から選択</Button> */}
                        <div class="button" style={{ margin: "0 0 10px" }}>
                          <input type="button" onClick={handleClickOpen} class="buttonDefault" value="一覧から選択" />
                        </div>

                        <div class="text">
                          <Autocomplete
                            id="nouyaku"
                            className="d001_text"
                            value={autocompletePesticide}
                            multiple // 複数選択
                            freeSolo // 開閉をなくす
                            options={pesticideOptions}
                            onInputChange={(e, changeValue) => {
                              pesticideSearchHandler(changeValue);
                            }} // テキスト内容変更時
                            onChange={pesticideChange} // 選択状態変更時
                            renderTags={(tagValue, getTagProps) =>
                              tagValue.map((option, index) => (
                                <Chip
                                  label={label(option)}
                                  {...getTagProps({ index })}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="例）アイオキシニル等キーワード入力"
                                error={Boolean(errorPesticide == "" ? false : true)}
                                // Enter無効
                                inputProps={{
                                  ...params.inputProps,
                                  onKeyDown: (e) => {
                                    if (e.key === 'Enter') {
                                      e.stopPropagation();
                                    }
                                  },
                                }}
                              />
                            )}
                            filterOptions={(options) => options} // オートコンプリートの検索処理をなくす
                            getOptionLabel={(option) => label(option)}
                          />
                        </div>

                      </dd>
                    </dl>
                    <FormControl error={errorPesticide}>
                      <FormHelperText>{errorPesticide}</FormHelperText>
                    </FormControl>
                  </Stack>
                </div>

                <div class="selectSearchArea">
                  <Stack>
                    <dl>
                      <dt>
                        <FormLabel >農薬の製品名</FormLabel>
                      </dt>

                      <dd>
                        {/* <Button onClick={handleClickOpen}>一覧から選択</Button> */}
                        <div class="button" style={{ margin: "0 0 10px" }}>
                          <input type="button" onClick={handlePesticideProductsClickOpen} class="buttonDefault" value="一覧から選択" />
                        </div>

                        <div class="text">
                          <Autocomplete
                            id="seihinmei"
                            className="d001_text"
                            value={autocompletePesticideProducts}
                            multiple // 複数選択
                            freeSolo // 開閉をなくす
                            options={pesticideProductsOptions}
                            onInputChange={(e, pesticideProductsChangeValue) => {
                              pesticideProductsSearchHandler(pesticideProductsChangeValue);
                            }} // テキスト内容変更時
                            onChange={pesticideProductsChange} // 選択状態変更時
                            renderTags={(tagValue, getTagProps) =>
                              tagValue.map((option, index) => (
                                <Chip
                                  label={pesticideProductsLabel(option)}
                                  {...getTagProps({ index })}
                                />
                              ))
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="例）ACCｺﾝﾎﾞﾗﾙ等キーワード入力"
                                error={Boolean(errorPesticideProducts == "" ? false : true)}
                                // Enter無効
                                inputProps={{
                                  ...params.inputProps,
                                  onKeyDown: (e) => {
                                    if (e.key === 'Enter') {
                                      e.stopPropagation();
                                    }
                                  },
                                }}
                              />
                            )}
                            filterOptions={(options) => options} // オートコンプリートの検索処理をなくす
                            getOptionLabel={(option) => pesticideProductsLabel(option)}
                          />
                        </div>

                      </dd>
                    </dl>
                    <FormControl error={errorPesticideProducts}>
                      <FormHelperText>{errorPesticideProducts}</FormHelperText>
                    </FormControl>
                  </Stack>
                </div>

                {standardValueData}

              </Stack>
            </Container>

            <div className="dialog">
              <Dialog
                fullWidth
                maxWidth="md"
                Height="md"
                fullScreen={fullScreen}
                open={open}
                onClose={cancelButton}
                aria-labelledby="responsive-dialog-title"
              >
                <BootstrapDialogTitle id="customized-dialog-title" style={{ backgroundColor: "#1B335E", color: "#fff", textAlign: "center" }} onClose={cancelButton}>
                  農薬の有効成分名一覧
                </BootstrapDialogTitle>
                <ToggleButtonGroup
                  color="primary"
                  value={dialogLangu}
                  exclusive
                  onChange={languChange}
                  aria-label="Platform"
                >
                  <ToggleButton value="ja" style={{ width: "50%" }}>和名</ToggleButton>
                  <ToggleButton value="en" style={{ width: "50%" }}>英名</ToggleButton>
                </ToggleButtonGroup>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  {isJa ?
                    <Tabs
                      value={jaValue}
                      onChange={jaDialigChange}
                      aria-label="basic tabs example"
                      variant="scrollable"
                      scrollButtons
                      allowScrollButtonsMobile
                      TabIndicatorProps={{
                        style: {
                          backgroundColor: '#B00002',
                        }
                      }}
                    >
                      {jaPesticideTabs}
                    </Tabs>
                    : null}
                  {isEn ?
                    <Tabs
                      value={enValue}
                      onChange={enDialigChange}
                      aria-label="basic tabs example"
                      variant="scrollable"
                      scrollButtons
                      allowScrollButtonsMobile
                      TabIndicatorProps={{
                        style: {
                          backgroundColor: '#B00002',
                        }
                      }}
                    >
                      {enPesticideTabs}
                    </Tabs>
                    : null}
                </Box>
                <DialogContent id="dialog-content">
                  <TabPanel value={0} index={0}>
                    <div hidden={!isJa}>{jaPesticideDialogContent}</div>
                    <div hidden={!isEn}>{enPesticideDialogContent}</div>
                  </TabPanel>
                </DialogContent>
                <div style={{ textAlign: "center" }}>
                  <FormControl error={errorDialogPesticide}>
                    <FormHelperText>{errorDialogPesticide}</FormHelperText>
                  </FormControl>

                  <div style={{
                    display: "flex"
                    , justifyContent: "center"
                    , position: "relative"
                    , flexWrap: "wrap"
                    // , marginTop: "40px"
                    , marginBottom: "40px"
                  }}>
                    <input type="button" style={{ width: "150px", margin: "0 10px" }} value="キャンセル" class="buttonDefault modalClose graylBtn" onClick={cancelButton} />
                    <input type="button" style={{ width: "150px", margin: "0 10px" }} value="決定" class="buttonDefault" onClick={decisionButton} />
                  </div>
                </div>
              </Dialog>
            </div>
            
            <div className="dialog">
              <Dialog
                fullWidth
                maxWidth="md"
                Height="md"
                fullScreen={fullScreen}
                open={pesticideProductsOpen}
                onClose={cancelButton}
                aria-labelledby="responsive-dialog-title"
              >
                <BootstrapDialogTitle id="pesticide-products-dialog-title" style={{ backgroundColor: "#1B335E", color: "#fff", textAlign: "center" }} onClose={cancelButton}>
                  農薬の製品名一覧
                </BootstrapDialogTitle>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    {/* <Tabs
                      value={jaValue}
                      onChange={jaDialigChange}
                      aria-label="basic tabs example"
                      variant="scrollable"
                      scrollButtons
                      allowScrollButtonsMobile
                      TabIndicatorProps={{
                        style: {
                          backgroundColor: '#B00002',
                        }
                      }}
                    >
                    </Tabs> */}
                </Box>
                <DialogContent id="dialog-content">
                  <TabPanel value={0} index={0}>
                    <div>{pesticideProductsDialogContent}</div>
                  </TabPanel>
                </DialogContent>
                <div style={{ textAlign: "center" }}>
                  <FormControl error={errorDialogPesticideProducts}>
                    <FormHelperText>{errorDialogPesticideProducts}</FormHelperText>
                  </FormControl>

                  <div style={{
                    display: "flex"
                    , justifyContent: "center"
                    , position: "relative"
                    , flexWrap: "wrap"
                    // , marginTop: "40px"
                    , marginBottom: "40px"
                  }}>
                    <input type="button" style={{ width: "150px", margin: "0 10px" }} value="キャンセル" class="buttonDefault modalClose graylBtn" onClick={cancelButton} />
                    <input type="button" style={{ width: "150px", margin: "0 10px" }} value="決定" class="buttonDefault" onClick={decisionPesticideProductsButton} />
                  </div>
                </div>
              </Dialog>
            </div>

          </div>

          <div class="popularItemWrap">
            <div class="popularItem">
              <p class="h2En">FEATURED ITEM</p>
              <h2>よく見られている品目</h2>
              <div class="popularItemList">
                <ul>
                  {seenProductList}
                </ul>
                <div style={isProductOpen ? { display: "block" } : { display: "none" }}>
                  <ul>
                    {hideProductList}
                  </ul>
                </div>
                <span class={isProductOpen ? "openTrigger isOpen" : "openTrigger"} onClick={() => ProductClick()}></span>
              </div>
            </div>
            <div class="popularItem">
              <p class="h2En">DESTINATION COUNTRY </p>
              <h2>よく見られている輸出先国</h2>
              <div class="popularItemList">
                <ul>
                  {seenCountryList}
                </ul>
                <div style={isCountryOpen ? { display: "block" } : { display: "none" }}>
                  <ul>
                    {hideCountryList}
                  </ul>
                </div>
                <span class={isCountryOpen ? "openTrigger isOpen" : "openTrigger"} onClick={() => CountryClick()}></span>
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );
};

export default D0121RacTop;